var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22L16 18L13.5 7L14.493 4.351C14.5497 4.19974 14.5689 4.03699 14.549 3.87669C14.5291 3.71638 14.4706 3.56329 14.3786 3.43051C14.2866 3.29772 14.1638 3.1892 14.0207 3.11423C13.8777 3.03925 13.7185 3.00006 13.557 3H10.443C10.2815 3.00006 10.1223 3.03925 9.97926 3.11423C9.83617 3.1892 9.71338 3.29772 9.62138 3.43051C9.52939 3.56329 9.47093 3.71638 9.45101 3.87669C9.43109 4.03699 9.4503 4.19974 9.507 4.351L10.5 7L8 18L12 22Z",
    stroke: "#6C6C6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7H13.5L18.5 12.5",
    stroke: "#6C6C6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/Tie.f8e9d94b9608827dd0c6e0554b42295a.svg";
export { ForwardRef as ReactComponent };